import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  cpf: Yup.string().required(),
  cpfCnpj: Yup.string().required(),
});

export default validationSchema;
